<section class="display-column-flex flex-1">
  <p class="text-small text-uppercase bold color--dark-blue-grey lineheight--condensed mt--none mb--sm">
    {{ 'App.Admin.Dashboard.Revenue.Title' | translate }}
  </p>
  @if (report) {
    <app-report-data-warning
      [comparisonPeriod]="report.comparisonPeriod"
      [dataSince]="report.dataSince"
      [selectedRange]="selectedRange">
    </app-report-data-warning>
    @if (hasData) {
      <mat-card class="commission-overview flex-1">
        <div class="commission-overview__content commission-overview__content--compact">
          <div class="commission-overview__total">
            <mat-card-header>
              <mat-card-title>{{ 'App.Admin.Dashboard.Revenue.Title' | translate }}</mat-card-title>
              <mat-card-subtitle>{{ 'App.Admin.Dashboard.Revenue.Subtitle' | translate }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div>
                <p class="commission-overview__value bold color--navy lineheight--none mt--none mb--xs">
                  {{ report.totals.total.value | currency:'CAD':'symbol-narrow':'1.2-2' }}
                </p>
                <app-comparison-badge
                  [value]="comparisonValue"
                  [digits]="hasPercent ? 1 : 2"
                  [prefix]="hasPercent ? '' : '$'"
                  [suffix]="hasPercent ? '%' : ''">
                </app-comparison-badge>
              </div>
            </mat-card-content>
          </div>
          <div class="commission-overview__sources">
            <mat-card-header>
              <mat-card-title>{{ 'App.Admin.Dashboard.Revenue.BySource' | translate }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="commission-sources">
                @for (source of sourceRows; track source.key) {
                  <div class="commission-source commission-source--{{ source.key }}">
                    <span>{{ source.label | translate }}</span>
                    <span class="commission-source__track bg--lighter-grey">
                      <span class="commission-source__fill display-block h-100" [style.width.%]="source.width"></span>
                    </span>
                    <strong>{{ source.value | currency:'CAD':'symbol-narrow':'1.2-2' }}</strong>
                  </div>
                }
              </div>
            </mat-card-content>
          </div>
        </div>
      </mat-card>
    } @else {
      <mat-card class="flex-1">
        <mat-card-content class="display-flex justify-content-center py--lg">
          <app-no-data [message]="(report.dataSince
            ? 'App.Admin.Dashboard.Revenue.NoRevenue'
            : 'App.Admin.Dashboard.Revenue.NoReportingData') | translate">
          </app-no-data>
        </mat-card-content>
      </mat-card>
    }
  }
</section>
